import React from "react";
import { currentSite } from "../../Config/siteConfig";
export default function () {
  return (
    <div className="flex flex-col  items-center justify-center w-full h-auto bg-primary7">
      <div className="flex width items-center justify-center w-full  border-t-2 border-[#1B99D4] ">
        <div className="width md:w-[70%] w-[80%]  mt-[0.1rem] flex items-center justify-between  ">
          <div className="flex w-[50%] px-2 sm:px-0">
            <div className="text-[#ffffff] font-opensans 2xl:text-xs md:text-[0.6rem] text-[0.3rem]">
              Copyright © 2023 I
            </div>
            <div className="text-[#1B99D4] font-opensans 2xl:text-xs md:text-[0.6rem] text-[0.3rem]">
              {currentSite === "site1" ? "Qulabs" : "Quantum AI Global"}
            </div>
          </div>
          <div className="flex items-center justify-end w-[50%]">
            <div className="text-[#ffffff] font-opensans 2xl:text-xs md:text-[0.6rem] text-[0.3rem]">
              All Rights Reserved
            </div>
            <div className="text-[#1B99D4] font-opensans 2xl:text-xs md:text-[0.6rem] text-[0.3rem]">
              | Terms and Conditions | Privacy Policy
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
